import TiclickTable from '@src/design-system/molecules/ticlick-table';
import { PageContainer } from '@src/shared/components/page-container';
import { PageTitle } from '@src/shared/components/page-title';
import { useUniversitiesTable } from '../../hooks/use-universities-table';
import { ViewUniversityDialogFromUrl } from './view-university-dialog';

export function Universities() {
  const { table, actionsTable } = useUniversitiesTable();

  return (
    <PageContainer>
      <div className='flex items-center gap-2.5'>
        <PageTitle titles={['Universities']} />
      </div>
      <div className='p-4 rounded-lg border bg-white border-pale-border [&_td]:text-gray-900 [&_th]:text-gray-800 [&_th]:h-12 [&_th]:font-bold [&_th]:text-sm'>
        <TiclickTable
          table={table}
          actions={actionsTable}
        />
      </div>
      <ViewUniversityDialogFromUrl />
    </PageContainer>
  );
}

export default Universities;
